import { z } from 'zod';

import { CollectionSchema } from './collections';
import { createOffsetPaginationRequestQuerySchema } from './pagination';
import { SourceSchema } from './sources';
import { PrimaryKeySchema, commaDelimitedList } from './utils';

/**
 * A collection file source is a link between a collection and a file source
 */
export const CollectionSourceSchema = z.object({
  collectionSourceId: PrimaryKeySchema,
  collectionId: CollectionSchema.shape.collectionId,
  sourceId: SourceSchema.shape.sourceId,
  createdAt: z.coerce.date(),
});

export type CollectionSource = z.infer<typeof CollectionSourceSchema>;

export const CollectionSourcesSchema = z.array(CollectionSourceSchema);

export type CollectionSources = z.infer<typeof CollectionSourcesSchema>;

export const CollectionSourcesQuerySchema = z
  .object({
    collectionIds: commaDelimitedList(
      CollectionSchema.shape.collectionId.array(),
    ).optional(),
    sourceIds: commaDelimitedList(
      SourceSchema.shape.sourceId.array(),
    ).optional(),
  })
  .merge(createOffsetPaginationRequestQuerySchema(z.enum(['createdAt'])));

export type CollectionSourcesQuery = z.infer<
  typeof CollectionSourcesQuerySchema
>;
